

export function deepCopy(obj){
    if(!obj){
        return {};
    }
    return JSON.parse(JSON.stringify(obj));
}